import { Flag } from "@phosphor-icons/react"

import { Button } from "~/components/design-system/components"
import { OrganizationFeatureFlags } from "~/features/feature-flags/client/OrganizationFeatureFlags"
import {
  DialogBodyV2,
  DialogContentV2,
  DialogHeaderV2,
  DialogRoot,
  DialogTitle,
  DialogTrigger,
} from "~/components/reusable/Dialog"
import { Tooltip } from "~/components/reusable/Tooltip"

/** A company's flag count that opens its feature flags, for list rows. */
export function OrganizationFlagsButton({
  organization,
  activeCount,
  totalCount,
}: {
  organization: { id: string; display_name: string }
  activeCount?: number
  totalCount?: number
}) {
  const hasCounts = activeCount !== undefined && totalCount !== undefined
  return (
    <DialogRoot>
      <Tooltip title="Flags on for this company">
        <DialogTrigger asChild>
          <Button size="xs" variant="transparent" onClick={(event) => event.stopPropagation()}>
            <Flag />
            {hasCounts ? `${activeCount} / ${totalCount}` : "Flags"}
          </Button>
        </DialogTrigger>
      </Tooltip>
      <DialogContentV2
        className="flex h-[85vh] w-full max-w-6xl flex-col"
        onClick={(event) => event.stopPropagation()}
      >
        <DialogHeaderV2>
          <DialogTitle>Feature flags: {organization.display_name}</DialogTitle>
        </DialogHeaderV2>
        <DialogBodyV2 className="max-h-none min-h-0 flex-1">
          <OrganizationFeatureFlags orgId={organization.id} />
        </DialogBodyV2>
      </DialogContentV2>
    </DialogRoot>
  )
}
